function waitForElement(selector) {
  return new Promise((resolve) => {
    const observer = new MutationObserver((mutations, observer) => {
      const element = document.querySelector(selector);
      if (element) {
        observer.disconnect();
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElement(".gm-menu").then((element) => {
  var parent_menu = jQuery('.header-menu-color--red');
  parent_menu.each(function(){
    jQuery(this).children('a').children().attr('style', 'color: #e65550 !important');;
  });
});

jQuery('document').ready(function($){
  var container = $('div#gf-products');
  container.replaceWith('<ul id="gf-products" data-id="template--18233394102430__product-grid" class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop collection-quick-add-bulk" data-globo-filter-items="" old-id="product-grid" style="min-height: auto;"></ul>');
});

// cart-drawer-tracker
(function () {
  // Store last known discounted total so we can re-apply after drawer re-renders
  window.__dnLastDiscountedTotalCents = window.__dnLastDiscountedTotalCents ?? null;

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    return (cents / 100).toFixed(2);
  }

  function updateProgressBar(totalCents) {
    const bars = document.querySelectorAll('[data-progress-bar]');
    if (!bars.length) return;

    bars.forEach((bar) => {
      const container = bar.closest('.upsell-container');
      if (!container) return;

      const msg = container.querySelector('.shipping-message');
      if (!msg) return;

      const threshold = parseInt(msg.dataset.freeShippingThreshold, 10) || 0;
      if (!threshold) return;

      const percentage = Math.min((totalCents / threshold) * 100, 100);

      bar.style.width = `${percentage}%`;
      bar.setAttribute('aria-valuenow', Math.round(percentage));
    });
  }

  function render(el, totalCents) {
    if (!el || typeof totalCents !== 'number') return;

    const threshold = parseInt(el.dataset.freeShippingThreshold, 10) || 0;
    const moneyFormat = el.dataset.moneyFormat || '${{amount}}';
    const textEl = el.querySelector('.js-free-shipping-text');
    if (!textEl) return;

    const left = Math.max(threshold - totalCents, 0);
    textEl.textContent =
      left > 0 ? `You are ${formatMoney(left, moneyFormat)} away from free shipping!` : `You have free shipping!`;

    updateProgressBar(totalCents);
  }

  // Render all current instances (drawer may have multiple depending on theme)
  function renderAll() {
    const total = window.__dnLastDiscountedTotalCents;
    document.querySelectorAll('.shipping-message').forEach((el) => render(el, total));
  }

  // 1) Listen to Discount Ninja recalcs and store latest total
  function handleDN(event) {
    const dc = event?.detail?.data?.[0];
    if (!dc) return;

    // Pick the right basis for your free shipping rule:
    // - subtotal.discountedPrice (common: after product discounts)
    // - total.discountedPrice (after order-level discounts too)
    const totalCents = dc.subtotal?.discountedPrice ?? dc.total?.discountedPrice;
    if (typeof totalCents !== 'number') return;

    window.__dnLastDiscountedTotalCents = totalCents;
    renderAll();
  }

  document.addEventListener('la:dn:cart:updated', handleDN);
  document.addEventListener('la:dn:cart:discounted', handleDN);

  // Also try immediate read (optional)
  const dc0 = window.discountNinja?.api?.discountedCart?.content;
  if (dc0) {
    const totalCents = dc0.subtotal?.discountedPrice ?? dc0.total?.discountedPrice;
    if (typeof totalCents === 'number') window.__dnLastDiscountedTotalCents = totalCents;
  }

  // 2) Watch for drawer HTML being replaced and re-apply the stored DN total
  // This catches section renders / innerHTML swaps.
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;

      // If any new node contains a shipping-message, re-render
      const added = [...m.addedNodes].filter((n) => n.nodeType === 1);
      if (added.some((n) => n.matches?.('.shipping-message') || n.querySelector?.('.shipping-message'))) {
        renderAll();
        break;
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

  // One initial pass
  renderAll();
})();